import request from "./request";
const API_PREFIX = "/mp/login";

/**
 * 登录
 * @param {Object} params - { code: 微信 OAuth2 回调参数 code }
 */
export function userMiniLogin(params = {}) {
  return request({
    url: `${API_PREFIX}/doLogin`,
    method: "get",
    params,
  });
}

/**
 * 注册新用户 / 完善账号信息
 * username 对应用户手机号，password 为开锁密码或登录密码
 */
export function registerNewUser(data) {
  return request({
    url: `${API_PREFIX}/registerNewUser`,
    method: "post",
    data,
  });
}

/**
 * 发送验证码 mobile
 * @param {Object} params - { mobile: 手机号 }
 */
export function sendCode(params = {}) {
  return request({
    url: `${API_PREFIX}/sendRegisterCode`,
    method: "get",
    params,
  });
}

/**
 * 退出登录
 */
export function loginOut() {
  return request({
    url: `${API_PREFIX}/loginOut`,
    method: "get",
  });
}

/**
 * 修改开锁密码（与注册时 4 位数字密码一致）
 * @param {Object} params - { newPassword: string }
 */
export function updatePassword(params = {}) {
  return request({
    url: `${API_PREFIX}/updatePassword`,
    method: "get",
    params,
  });
}
